<template>
  <div class="productIndexPage tinyScreenProductIndex">
    <Header></Header>
    <!-- 登录正文 -->
    <div  class="sectionLogin" ref="qwcontent">
        <div class="container relative" style="height: 100%;">
          <!-- 登录 -->
          <div class="loginPart" v-if="isActive == 1" ref="logincontent">
            <div class="header">
              <img class="titlePic" height="28px" src="../../assets/picture/product/loginTitle.png">
              <!-- <span class="title">{{$t('productIndex.userLogin')}}</span> -->
              <img class="headerPic" height="100%" src="../../assets/picture/product/t13.png">
            </div>
            <div class="contain">
              <div class="inputBox">
                <span class="title">{{$t('productIndex.userName')}}</span>
                <input type="text" v-model="loginForm.username" :placeholder="$t('productIndex.userNamePlaceholder')" name="">
              </div>
               <div class="inputBox">
                <span>{{$t('productIndex.password')}}</span>
                <input type="password"  v-model="loginForm.password" :placeholder="$t('productIndex.passwordPlaceholder')" name="">
              </div>
            </div>
            <div class="footer">
                <div class="loginNow" @click="login">{{$t('productIndex.loginNow')}}</div>
                <!-- <div @click="login" class="loginNow">立即登录</div> -->
                <!-- <div class="forgetPass">{{$t('productIndex.forget')}}</div> -->
              <!--   <div @click="isActive = 2" class="forgetPass">{{$t('productIndex.forget')}}</div> -->
            </div>
          </div>
          <!-- 找回密码 -->
          <div class="findBox" v-if="isActive == 2">
            <div>
              <ul>
                <li>
                  <div></div>
                  <span class="txt" @click="isFindPhone">{{$t('productIndex.findPhone')}}</span>
                </li>
                <li>
                  <div></div>
                  <span class="txt" @click="isFindEmail">{{$t('productIndex.findEmail')}}</span>
                </li>
              </ul>
            </div>
          </div>
          <!-- 通过邮箱找回 -->
          <div class="findEmail" v-if="isActive == 4">
            <div class="header">
              <img width="145px" src="../../assets/picture/product/findPass.png">
              <img width="220px" src="../../assets/picture/product/Group.png">
            </div>
            <div class="contain">
              <div class="inputBox">
                <span>{{$t('productIndex.userName')}}</span>
                <input type="text" :placeholder="$t('productIndex.userNameFindPlaceholder')" name="">
              </div>
              <!-- <div class="block" style="margin-left: 20px;">
                <el-slider v-model="value3" :show-tooltip="false">按住左边滑块，滑动至右边确认</el-slider>
              </div> -->
                <div class="drag"  ref="dragDiv">
                    <div class="drag_bg"></div>
                    <div class="drag_text">{{confirmWords}}</div>
                    <div ref="moveDiv" @mousedown="mousedownFn($event)" :class="{'handler_ok_bg':confirmSuccess}" class="handler handler_bg" style="position: absolute;top: 0px;left: 0px;"></div>
                </div>
             
               <div class="inputBox pt15">
                <span>{{$t('productIndex.bindEmail')}}</span>
                <input type="text" :placeholder="$t('productIndex.bindEmailPlaceholder')"  name="">
              </div>
            </div>
            <div class="footer">
                <div class="loginNow">{{$t('productIndex.sendEmail')}}</div>
            </div>
          </div>
           <!-- 通过手机号码找回 -->
          <div class="findEmail" v-if="isActive == 3">
            <div class="header">
              <img width="145px" src="../../assets/picture/product/findPass.png">
              <img width="220px" src="../../assets/picture/product/Group.png">
            </div>
            <div class="contain">
              <div class="inputBox">
                <span>{{$t('productIndex.userName')}}</span>
                <input type="text" :placeholder="$t('productIndex.userNamePlaceholder')" name="">
              </div>
              <!-- <div class="block" style="margin-left: 20px;"> 
                <el-slider v-model="value3" :show-tooltip="false">按住左边滑块，滑动至右边确认</el-slider>
              </div> -->
              <div class="dragEmail"  ref="dragDivEmail">
                    <div class="drag_bgEmail"></div>
                    <div class="drag_textEmail">{{confirmWords}}</div>
                    <div ref="moveDivEmail" @mousedown="mousedownFnEmail($event)" :class="{'handler_ok_bgEmail':confirmSuccessEmail}" class="handlerEmail handler_bgEmail" style="position: absolute;top: 0px;left: 0px;"></div>
                </div>
              <div class="flex">
                  <div class="inputBox pt20 w50">
                    <span>{{$t('productIndex.bindPhone')}}</span>
                    <input type="password" class="wAuto" :placeholder="$t('productIndex.bindPhonePlaceholder')" name="">
                  </div>
                  <span class="borderR"></span>
                  <div class="inputBox pt20 w50 pl30 relative">
                    <span>{{$t('productIndex.code')}}</span>
                    <input type="password"  class="wAuto" :placeholder="$t('productIndex.codePlaceholder')" name="">
                  </div>
                  <span class="sendCode">{{$t('productIndex.sendCode')}}</span>
              </div>  
              <div class="inputBox">
                <span>{{$t('productIndex.newPassword')}}</span>
                <input type="password" :placeholder="$t('productIndex.newPasswordPlaceholder')" name="">
              </div>            
               <div class="inputBox">
                <span>{{$t('productIndex.confirmPassword')}}</span>
                <input type="password" :placeholder="$t('productIndex.newPasswordPlaceholder')" name="">
              </div>
            </div>
            <div class="footer">
                <div class="loginNow">{{$t('productIndex.confirmPassword')}}</div>
            </div>
          </div>
          <img  v-if="isActive == 1" height="66px" class="conPic" ref="conPic" src="../../assets/picture/product/productTitle.png">
        </div>
    </div>
    <!-- footer -->
    <Footer></Footer>
    <!-- 合格投资者认定 -->
    <el-dialog class="cognizanceBox"
      :title="$t('productIndex.agreement')"
      :visible.sync="centerDialogVisible"
      width="50%" :show-close="false"
      center>
      <p class="downTxt t2em" v-html="content"></p>
      <span slot="footer" class="dialog-footer">
        <el-button class="admitBtn" type="primary" @click="centerDialogVisible = false">同 意</el-button>
        <el-button class="cancelBtn" @click="goHome">不同意</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Header from '../common/header';
import Footer from '../common/footer';
export default {
  data() {
    return {
      beginClientX:0,           /*距离屏幕左端距离*/
      mouseMoveStata:false,     /*触发拖动状态  判断*/
      maxwidth:'',               /*拖动最大宽度，依据滑块宽度算出来的*/
      confirmWords:'按住左边滑块验证',   /*滑块文字*/
      confirmSuccess:false,          /*验证成功判断*/
      // **********************
      beginClientXEmail:0,           /*距离屏幕左端距离*/
      mouseMoveStataEmail:false,     /*触发拖动状态  判断*/
      maxwidthEmail:'',               /*拖动最大宽度，依据滑块宽度算出来的*/
      confirmWordsEmail:'按住左边滑块验证',   /*滑块文字*/
      confirmSuccessEmail:false,          /*验证成功判断*/

      content:'',
      value3:0,
      isActive:1,
      centerDialogVisible:true,
      fullHeight: '',//fullHeight: document.documentElement.clientHeight  屏幕高度 默认值
      liIndex:-1,
      isShowSearch:false,    
      loginForm: {
        username: "",
        password: ""
      },
      //表单验证规则对象
      loginFormRules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ]
      },
    };
  },
  components: { Header,Footer },
  mounted(){
    this.getFullHeight();
    this.getHegeTouzi();
  },
  beforeMount(height) {
    var w = document.documentElement.clientWidth;
    if(w<1023 || w==1023){
      this.$router.push({  
            path: '/phoneAggrement',       
      });
    }
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.curHeight =h - height; //减去页面上固定高度height
  },
  watch: {
      // 如果 `fullHeight ` 发生改变，这个函数就会运行 
      fullHeight :function(val) {
        if(!this.timer) {
          this.fullHeight = val
          this.changeFixed(this.fullHeight)
          this.timer = true
          let that = this
          setTimeout(function (){//频繁触发 resize 函数，会导致页面很卡
            that.timer = false
          },100)
        }
      },
      isActive:function(val) {
        if(val == 3){
          var str = this.$refs.qwcontent.style.height;
          var h = str.split(".")[0];
          this.$refs.qwcontent.style.height = Number(h)+250+'px';
        }
      }
    },
  methods: {
    mousedownFn:function (e) {
      if(!this.confirmSuccess){
          e.preventDefault && e.preventDefault();   //阻止文字选中等 浏览器默认事件
          this.mouseMoveStata = true;
          this.beginClientX = e.clientX;
      }
    },        //mousedoen 事件
    successFunction(){
      this.confirmSuccess = true
      this.confirmWords = '';
      if(window.addEventListener){
        document.getElementsByTagName('html')[0].removeEventListener('mousemove',this.mouseMoveFn);
        document.getElementsByTagName('html')[0].removeEventListener('mouseup',this.moseUpFn);
      }else {
        document.getElementsByTagName('html')[0].removeEventListener('mouseup',()=>{});
      }
      document.getElementsByClassName('drag_text')[0].style.color = '#900211'
      document.getElementsByClassName('handler')[0].style.left = this.maxwidth + 'px';
      document.getElementsByClassName('drag_bg')[0].style.width = this.maxwidth + 'px';
   },                //验证成功函数
    mouseMoveFn(e){
        if(this.mouseMoveStata){
            let width = e.clientX - this.beginClientX;
            if(width>0 && width<=this.maxwidth){
                document.getElementsByClassName('handler')[0].style.left = width + 'px';
                document.getElementsByClassName('drag_bg')[0].style.width = width + 'px';
            }else if(width>this.maxwidth){
                this.successFunction();
            }
        }
    },                   //mousemove事件
    moseUpFn(e){
        this.mouseMoveStata = false;
        var width = e.clientX - this.beginClientX;
        if(width<this.maxwidth){
            document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
            document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px';
        }
    },
    // 获取邮件
     mousedownFnEmail:function (e) {
      if(!this.confirmSuccessEmail){
          e.preventDefault && e.preventDefault();   //阻止文字选中等 浏览器默认事件
          this.mouseMoveStataEmail = true;
          this.beginClientXEmail = e.clientX;
      }
    },        
    //mousedoen 事件
    successFunctionEmail(){
      this.confirmSuccessEmail = true
      this.confirmWordsEmail = '';
      if(window.addEventListener){
        document.getElementsByTagName('html')[0].removeEventListener('mousemove',this.mouseMoveFnEmail);
        document.getElementsByTagName('html')[0].removeEventListener('mouseup',this.moseUpFnEmail);
      }else {
        document.getElementsByTagName('html')[0].removeEventListener('mouseup',()=>{});
      }
      document.getElementsByClassName('drag_textEmail')[0].style.color = '#900211'
      document.getElementsByClassName('handlerEmail')[0].style.left = this.maxwidthEmail + 'px';
      document.getElementsByClassName('drag_bgEmail')[0].style.width = this.maxwidthEmail + 'px';
   },                //验证成功函数
    mouseMoveFnEmail(e){
        if(this.mouseMoveStataEmail){
            let width = e.clientX - this.beginClientXEmail;
            if(width>0 && width<=this.maxwidthEmail){
                document.getElementsByClassName('handlerEmail')[0].style.left = width + 'px';
                document.getElementsByClassName('drag_bgEmail')[0].style.width = width + 'px';
            }else if(width>this.maxwidthEmail){
                this.successFunctionEmail();
            }
        }
    },                   //mousemove事件
    moseUpFnEmail(e){
        this.mouseMoveStataEmail = false;
        var width = e.clientX - this.beginClientXEmail;
        if(width<this.maxwidthEmail){
            document.getElementsByClassName('handlerEmail')[0].style.left = 0 + 'px';
            document.getElementsByClassName('drag_bgEmail')[0].style.width = 0 + 'px';
        }
    },
      // 获取合格投资者认定
      async getHegeTouzi() {
          const { data: res } = await this.$http.get("/article/getHegeTouzi.do");
          // 提示message
          if (res.code !== 200) return this.$message.error(res.message);
          this.content = res.data.content;
      },
     formatTooltip(val) {
        return val / 100;
      },
     changeFixed(fullHeight){                        //动态修改样式
      this.$refs.qwcontent.style.height =( 0.91*fullHeight - 85)+'px';
      let h = 0.91*fullHeight - 85;
      // this.$refs.logincontent.style.marginTop =( Number(h) - 600)/2+'px';
      this.$refs.conPic.style.top =( Number(h) - 105)/2+'px';
     },
    getFullHeight(){
      this.fullHeight= `${document.documentElement.clientHeight}`;//默认值
      const that = this
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeigh
          that.fullHeight = window.fullHeight
        })()
      }
    },
    showSearch(){
      this.isShowSearch = !this.isShowSearch;
    },
    goHome(){
      this.$router.push({  
            path: '/',       
        });
      let navIndex = -1;
      localStorage.setItem('navIndex',navIndex);
    },
    isFindEmail(){
      this.isActive = 4;
      this.$nextTick(function(){
        this.maxwidth = this.$refs.dragDiv.clientWidth;
      })   
      document.getElementsByTagName('html')[0].addEventListener('mousemove',this.mouseMoveFn);
      document.getElementsByTagName('html')[0].addEventListener('mouseup',this.moseUpFn);
    },
    isFindPhone(){
      this.isActive = 3;
      this.$nextTick(function(){
        this.maxwidthEmail = this.$refs.dragDivEmail.clientWidth;
      })   
      document.getElementsByTagName('html')[0].addEventListener('mousemove',this.mouseMoveFnEmail);
      document.getElementsByTagName('html')[0].addEventListener('mouseup',this.moseUpFnEmail);
    },
    // 登录
    async login() {
        const { data: res } = await this.$http.post("/member/login.do?password="+this.loginForm.password+"&username="+this.loginForm.username);
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
        this.$message.success("登录成功");
        let id = res.data.id;
        this.$router.push({  
            path: 'productDetail',   
            query: {   
                id: id,   
            }      
        })
        // 保存token到sessionStorage，写入token键
        window.sessionStorage.setItem("token", res.data.token);
        window.sessionStorage.setItem("id", res.data.id);
    },
  }
};
</script>

<style lang="less" scoped>
.productIndexPage{
   .drag{
        position: relative;
        background-color: #F2F2F2;
        border-radius: 100px;
        width: 283px;
        height: 30px;
        margin-left: 20px;
        line-height: 30px;
        text-align: center;       
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9A9A9A;
        margin-top: 26px;
    }
    .handler{
        width: 34px;
        height: 34px;
        border-radius: 50%;
        background: #900211;
        cursor: move;
    }
    .handler_bg{
        margin-top: -2px;
        margin-left: -20px;
        background-color: #900211;
    }
    .handler_ok_bg{
        margin-top: -2px;
        margin-left: -20px;
        background-color: #900211;
        background-image:  url(../../assets/picture/product/success.png);
        background-repeat:  no-repeat;
        background-size:  100% 100%;
        background-position:  center;
    }
    .drag_bg{
        background-color: #900211;
        height: 30px;
        width: 0px;
        border-radius: 100px;
    }
    .drag_text{
        position: absolute;
        top: 0px;
        width: 100%;text-align: center;
        -moz-user-select: none;
        -webkit-user-select: none;
        user-select: none;
        -o-user-select:none;
        -ms-user-select:none;
    }
    /***************************************/
    .dragEmail{
        position: relative;
        background-color: #F2F2F2;
        border-radius: 100px;
        width: 283px;
        height: 30px;
        margin-left: 20px;
        line-height: 30px;
        text-align: center;       
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9A9A9A;
        margin-top: 26px;
    }
    .handlerEmail{
        width: 34px;
        height: 34px;
        border-radius: 50%;
        background: #900211;
        cursor: move;
    }
    .handler_bgEmail{
        margin-top: -2px;
        margin-left: -20px;
        background-color: #900211;
    }
    .handler_ok_bgEmail{
        margin-top: -2px;
        margin-left: -20px;
        background-color: #900211;
        background-image:  url(../../assets/picture/product/success.png);
        background-repeat:  no-repeat;
        background-size:  100% 100%;
        background-position:  center;
    }
    .drag_bgEmail{
        background-color: #900211;
        height: 30px;
        width: 0px;
        border-radius: 100px;
    }
    .drag_textEmail{
        position: absolute;
        top: 0px;
        width: 100%;text-align: center;
        -moz-user-select: none;
        -webkit-user-select: none;
        user-select: none;
        -o-user-select:none;
        -ms-user-select:none;
    }
  .sectionLogin{
      background-image: url(../../assets/picture/product/bg.png);
      background-repeat: no-repeat;
      background-size: cover;
      width: 100%;
      height: 100%;
      ::-webkit-input-placeholder { /* WebKit browsers */
        color: #9A9A9A;
      }

      ::-moz-placeholder { /* Mozilla Firefox 19+ */
        color: #9A9A9A;
      }
      
      :-ms-input-placeholder { /* Internet Explorer 10+ */
        color: #999;
      }  
      /*登录模块*/
      .loginPart{
        width: 40%;
        /*height:60%;*/
        background:#fff;
        transform: translateY(-50%);
        position: absolute;
        top:50%;
        .header{
          overflow-x:hidden;
          height: 10%;
          background: #353535;
/*          display: flex;*/
          align-items: center;
          .title{
            color: #fff;
            font-size: 25px;
            margin-left: 30px;
            margin-top: 40px;
            margin-right: 105px;
            font-weight: 100;
        }
          .titlePic{
            /*margin:45px 63px 0 38px;*/
            align-items:center;
            margin-left: 38px;
            width: 25%;
            margin-top: 30px;
            object-fit: scale-down;
          }
          .headerPic{
            width: 40%;
            float: right;
            margin-right: 20px;
            object-fit: scale-down;
          }
        }
        .contain{
          padding:0 38px;
          .inputBox{
            width: 100%;
            border-bottom: 1px solid #D5D5D5;;
            padding:5vh 0;
             span{                         
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #9A9A9A;
              line-height: 20px;
            }
            input{
              width: 80%;
              outline:none;
              margin-left: 16px;
              border:0;              
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #9A9A9A;
              line-height: 20px;
            }
          }
        }
        .footer{
          padding-top: 76px;
          background: #fff;
          padding-bottom: 15px;
          .loginNow{
            background: #900211;
            margin:0 auto;
            color: #fff;
            text-align: center;
            cursor: pointer;
            width: 224px;
            height: 44px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            line-height: 44px;
            letter-spacing: 10px;
          }
          .forgetPass{
            margin-top: 26px;
            text-align: center;           
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #9A9A9A;
            line-height: 20px;
            letter-spacing: 5px;
            cursor: pointer;
            margin-bottom: 30px;
          }
        }
      }
      /*忘记密码*/
      .findBox{
        ul{
          display: table;
          margin: 0 auto;
          margin-top: 296px;
           /deep/ .el-slider__runway{
            width: 284px;
            height: 30px;
            background: #F2F2F2;
            border-radius: 15px;
          }
          /deep/ .el-slider__bar{
            width: 284px;
            height: 30px;
            background: #900211;
            border-radius: 15px;
          }
          /deep/ .el-slider__button{
            width: 38px;
            border: none;
            margin-top:13px;
            height: 38px;
            background: #900211;
            border-radius: 100%;
            margin-left: -2px;
          }
          li:last-of-type{
            margin-top:54px;
          };
          li{
            width: 660px;
            height: 120px; 
            cursor: pointer;
            width: 660px;
            height: 120px;    
            background: url(../../assets/picture/product/findBox.png) no-repeat;  
            }
            .txt{
                display: block;
                color: #fff;
                font-size: 25px;
                margin-left: 30px;
                padding-top: 40px;
                letter-spacing: 6px;
                font-weight: 100;
            }
            img{
              margin:45px 0 39px 38px;
          }
        }
      }
      /*通过邮箱找回*/
      .findEmail{
        background: #fff;
        margin-left: 330px;
        width: 55%;
        transform: translateY(-50%);
        position: absolute;
        top: 50%;
        .header{
          width: 100%;
          height: 120px;
          background: #353535;       
          img:first-of-type{
            margin:39px 0 39px 38px;
          }
          img:last-of-type{
            float: right;
            margin-right: 20px;
          }
        }
        .contain{
          padding:0 38px;
           .sendCode{
            position: absolute;
            right: 40px;
            margin-top: 22px;
            color: #CD2A20;
            cursor: pointer;
          }
          /deep/ .el-slider__runway{
            width: 284px;
            height: 30px;
            background: #F2F2F2;
            border-radius: 15px;
          }
          /deep/ .el-slider__bar{
            width: 284px;
            height: 30px;
            background: #900211;
            border-radius: 15px;
          }
          /deep/ .el-slider__button-wrapper .hover{
            border:1px solid #fff;
          }
          /deep/ .el-slider__button{
            width: 38px;
            border: none;
            margin-top:13px;
            height: 38px;
            background: #900211;
            border-radius: 100%;
            margin-left: -2px;
          }
          .inputBox{
            width: 100%;
            border-bottom: 1px solid #D5D5D5;;
            padding:55px 0;
            span{                         
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #9A9A9A;
              line-height: 20px;
            }
            input{
              width: 85%;
              outline:none;
              margin-left: 16px;
              border:0;              
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #9A9A9A;
              line-height: 20px;
            }
          }
        }
        .footer{
          padding-top:59px;
          padding-bottom: 59px;
          background: #fff;
          .loginNow{
            width: 224px;
            height: 44px;
            background: #900211;
            margin:0 auto;
            color: #fff;
            text-align: center;
            line-height: 44px;
            cursor: pointer;
            letter-spacing: 10px;
          }
        }
      }
      .conPic{
        position: absolute;
        right: 0;
        height:50px;
        object-fit: scale-down;
      }
  }
  /*合格投资人认定*/
  .cognizanceBox{
    z-index:999;
    padding:52px 60px 72px 60px;
     /deep/ .el-dialog{
        background: #F2F2F2 !important;
      }
    /deep/ .el-dialog__title{
      font-size: 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #900211;
      line-height: 42px;
      letter-spacing: 2px;
    }
    /deep/ .el-dialog__body{
      padding: 0 20px 43px 60px;
      height: 520px;
      overflow-y: scroll;
      width: 97%;
    }
     /deep/ .el-dialog__body::-webkit-scrollbar {
        width: 4px;

      }
      /deep/ .el-dialog__body::-webkit-scrollbar-track {
        background-color: #D8D8D8;
        -webkit-border-radius: 2em;
        -moz-border-radius: 2em;
        border-radius: 2em;
      }
      /deep/ .el-dialog__body::-webkit-scrollbar-thumb {
        background-color: #900211;
        -webkit-border-radius: 2em;
        -moz-border-radius: 2em;
        border-radius: 2em;
      }
    /deep/ .el-dialog__header{
      padding:52px 0 21px 0;
    }
    /deep/ .el-dialog__footer{
      padding:43px 0 78px 0;
    }

    .upTxt{
      font-size: 14px;
      font-weight: bold;
      color:#333333;
      line-height: 30px;
    }
    .downTxt{
      font-size: 12px;
      color: #9A9A9A;
      line-height: 30px;
      letter-spacing: 1px;
    }
    .finalTxt{
      font-size: 12px;
      color: #9A9A9A;
      line-height: 30px;
      letter-spacing: 1px;
      text-align: right;
    }
    .admitBtn{
      width: 130px;
      height: 44px;
      background: #900211;
      text-align: center;
      color: #fff;
      font-size: 14px;
      border:none;
      border-radius: 0;
      margin-right: 80px;
    }
    .cancelBtn{
      width: 130px;
      height: 44px;
      background: #9A9A9A;
      text-align: center;
      color: #fff;
      font-size: 14px;
      border:none;
      border-radius: 0;
    }
  }
/*************************************************************/
 .section2{ 
    height: 430px;
    background: #1C1C1C;
    .section2Box{
       display: flex;
      .destiption{
        height: 88px;
        border-right: 3px solid #CD2A20;
        margin:188px 0 154px 83px;        
        font-size: 26px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #FFFFFF;
        line-height: 40px;
        padding-right: 40px;
      }
      .destiption:last-of-type{
        padding-right: 0;
        border:none;
        margin-left: 40px;
      }
    }
    
 }
}
</style>
